import { useTranslation } from 'react-i18next';
import { Link, Outlet } from '@tanstack/react-router';
import { SupportModal, NavbarDefault } from 'app/components';

const MyProfile = () => {
  const { t } = useTranslation('my-profile');

  return (
    <div className="grid--container full--height columns">
      <NavbarDefault />
      <div className="content">
        <div className="content-title">
          <h1>{t('title')}</h1>
        </div>
        <div className="menu--layout">
          <Link to="/myprofile" activeOptions={{ exact: true }} activeProps={{ className: 'active' }}>
            {t('menu.overview')}
          </Link>
          <Link to="/myprofile/info" activeProps={{ className: 'active' }}>
            {t('menu.insider')}
          </Link>
        </div>
        <Outlet />
      </div>
      <SupportModal />
    </div>
  );
};

export default MyProfile;
